import { awsClientGateway } from "./common/gateway";
import { logMessage } from "../utils/amplifyLogger";

export const clientLog = async (
  logging: Record<string, unknown>,
): Promise<void> => {
  try {
    await awsClientGateway({
      pathTemplate: "/clientLog",
      method: "POST",
      body: { ...logging },
    });
  } catch (err) {
    logMessage(
      `clientLog`,
      `Something went wrong in clientLog API : ${err}`,
      `error`,
    );
  }
};
